import React from "react";

export default function StatCard({ title, value, className = "card-2 printData" }) {
  return (
    <div className={className}>
      <h2>{title}</h2>
      <div className="totalEmission">{value}</div>
    </div>
  );
}